import 'Styles/apps/accept-invite.less';
import React from 'react';

import { withStyles } from '@material-ui/core/styles';
import { TextField, Typography } from '@material-ui/core';
import AsyncActionButton from 'Components/AsyncActionButton';
import { LogoMark } from 'Components/decor/Logo';
import { legacyPost } from 'Utils/rest.js';

const styles = (theme) => ({
  title: {
    maxWidth: '90%',
    borderBottom: '1px solid #999',
    paddingBottom: 25,
    margin: '0 auto',
  },
  container: {
    display: 'flex',
    flexDirection: 'column',
    maxWidth: '400px',
    margin: '0 auto',
  },
  tabBar: {
    backgroundColor: theme.palette.background.paper,
  },
  field: {
    marginBottom: theme.spacing(2),
  },
  error: {
    color: theme.palette.error.main,
  },
  actionButton: {
    marginTop: theme.spacing(6),
  },
});

class EmployeeAcceptInviteForm extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      password: '',
      firstName: props.invitation.user.firstName || '',
      lastName: props.invitation.user.lastName || '',
      loading: false,
      error: '',
    };
  }

  handleChange(name) {
    return (event) => {
      this.setState({
        [name]: event.target.value,
      });
    };
  }

  register() {
    const { firstName, lastName, password } = this.state;
    if (firstName == '' || lastName == '') {
      this.handleError('Your name is required.');
      return;
    }

    if (password == '') {
      this.handleError('Enter a password to create your account.');
      return;
    }

    const form = new FormData();
    form.append('invitationCode', this.props.invitationCode);
    form.append('firstName', firstName);
    form.append('lastName', lastName);
    form.append('password', password);

    this.setState({ loading: true });

    legacyPost('/accept-invite/employee', form)
      .then((response) => {
        this.setState({ loading: false });
        window.location = response.data.redirectUrl;
      })
      .catch((error) => {
        /*
          error.reponse.data example:
          {
            error: "Unauthorized"
            message: "An account under that email already exists."
            path: "/register"
            status: 401
          }
        */
        this.handleError(error.response.data.message);
      });
  }

  handleError(error) {
    this.setState({
      loading: false,
      error,
    });
  }

  handleKey(e) {
    if (e.key == 'Enter') {
      this.register();
    }
  }

  renderForm() {
    const { invitation, classes } = this.props;
    const { loading } = this.state;
    return (
      <div className='form'>
        <TextField
          disabled
          className={classes.field}
          label='Work Email'
          value={invitation.email}
        />
        <TextField
          className={classes.field}
          label='First Name'
          value={this.state.firstName}
          onChange={this.handleChange('firstName')}
        />
        <TextField
          className={classes.field}
          label='Last Name'
          value={this.state.lastName}
          onChange={this.handleChange('lastName')}
        />
        <TextField
          className={classes.field}
          id='password'
          name='password'
          label='Set Password'
          type='password'
          onChange={this.handleChange('password')}
        />
        <br />
        {this.state.error && (
          <p className={classes.error}>{this.state.error}</p>
        )}
        <AsyncActionButton
          fullWidth
          action={this.register.bind(this)}
          loading={loading}
        >
          Create Account
        </AsyncActionButton>
      </div>
    );
  }

  render() {
    const { classes, invitation } = this.props;
    return (
      <div className='accept-invite-container-team'>
        <div>
          <LogoMark size='small' />
          <Typography variant='h2' className={classes.title}>
            You&apos;ve been invited to join {invitation.orgName}
          </Typography>
          <p>
            Welcome,{' '}
            <strong>
              {invitation.name} ({invitation.email})
            </strong>
            ! Materio keeps everyone in sync by tracking all project details and
            decisions in one place.
          </p>
          <br />
          <br />

          <h3>Create an account</h3>
          <div className='form'>{this.renderForm()}</div>
        </div>
      </div>
    );
  }
}
export default withStyles(styles)(EmployeeAcceptInviteForm);
